import cloneDeep from 'lodash/cloneDeep';
import { createReducer } from '@reduxjs/toolkit';
import { setCreatedYamahaAccount } from '@yme/components/CheckoutForm/redux/actions';
import { Status } from '@yme/utils/constants';
import { addProductToCartFailure, addProductToCartRequest, addProductToCartSuccess, addProductToExternalCartRequest, changeShippingMethodFailure, changeShippingMethodRequest, changeShippingMethodSuccess, closeCartModal, getCartFailure, getCartRequest, getCartSuccess, getExternalCartSuccess, getExternalCartFailure, setHyperDriveEndpoint, changeItemQuantityRequest, changeItemQuantitySuccess, changeItemQuantityFailure, getShippingMethodsSuccess, setDeletingProduct, setCartLabels, validateStockRequest, validateStockSuccess, validateStockFailure, setValidationStockStatus, setInitialCartState, updateDiscountCodeRequest, updateDiscountCodeSuccess, updateDiscountCodeFailure, setCartErrorData, setIsLoadingCart, setCartQrId, updateShippingAddress, updateStockQuantityProduct, setCartState, addProductExternalToCartSuccess, addProductExternalToCartFailure, addPaymentFee, setDeletingCartItems, } from './actions';
export const initialState = {
    isAddingProduct: false,
    isOpenModal: false,
    isLoadingCart: false,
    data: null,
    paymentFee: null,
    errorData: null,
    hyperdriveEndpoints: {
        getCartById: '',
    },
    shippingMethods: [],
    deletingProduct: {
        sku: '',
        productName: '',
    },
    labels: {
        shoppingCart_confirmItemDeletePopUp_header: '',
        shoppingCart_confirmItemDeletePopUp_message: '',
        shoppingCart_emptyCart_description: '',
        shoppingCart_emptyCart_title: '',
        shoppingCart_header_label: '',
        shoppingCart_yourCart_header: '',
        shoppingCart_yourCartColorProperty_label: '',
        shoppingCart_yourCartPriceColumn_header: '',
        shoppingCart_yourCartProductColumn_header: '',
        shoppingCart_yourCartQtyColumn_header: '',
        shoppingCart_yourCartQuantitySelect_header: '',
        shoppingCart_orderSummaryProceedToCheckout_button: '',
        shoppingCart_nonCustomerRestriction_message: '',
    },
    validationStock: {
        status: null,
    },
    cartQrId: '',
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(addPaymentFee, (state, action) => ({
        ...state,
        paymentFee: action.payload,
    }))
        .addCase(addProductToCartRequest, (state) => ({
        ...state,
        isAddingProduct: true,
    }))
        .addCase(addProductToCartSuccess, (state, action) => ({
        ...state,
        isAddingProduct: false,
        isOpenModal: true,
        data: action.payload,
    }))
        .addCase(addProductToCartFailure, (state, action) => ({
        ...state,
        isAddingProduct: false,
        isOpenModal: true,
        errorData: action.payload,
    }))
        .addCase(getCartRequest, (state) => ({
        ...state,
        isLoadingCart: true,
    }))
        .addCase(getCartSuccess, (state, action) => ({
        ...state,
        data: action.payload,
        isLoadingCart: false,
    }))
        .addCase(getCartFailure, (state) => ({
        ...state,
        isLoadingCart: false,
    }))
        .addCase(closeCartModal, (state) => ({
        ...state,
        isOpenModal: false,
        errorData: null,
    }))
        .addCase(changeShippingMethodRequest, (state) => ({
        ...state,
        isLoadingCart: true,
    }))
        .addCase(changeShippingMethodSuccess, (state, action) => ({
        ...state,
        data: action.payload,
        isLoadingCart: false,
    }))
        .addCase(changeShippingMethodFailure, (state) => ({
        ...state,
        isLoadingCart: false,
    }))
        .addCase(setHyperDriveEndpoint, (state, action) => ({
        ...state,
        hyperdriveEndpoints: {
            getCartById: action.payload,
        },
    }))
        .addCase(changeItemQuantityRequest, (state) => ({
        ...state,
        isLoadingCart: true,
    }))
        .addCase(changeItemQuantitySuccess, (state, action) => ({
        ...state,
        data: action.payload,
        isLoadingCart: false,
    }))
        .addCase(changeItemQuantityFailure, (state) => ({
        ...state,
        isLoadingCart: false,
    }))
        .addCase(getShippingMethodsSuccess, (state, action) => ({
        ...state,
        shippingMethods: action.payload,
    }))
        .addCase(setDeletingProduct, (state, action) => ({
        ...state,
        deletingProduct: action.payload,
    }))
        .addCase(setCartLabels, (state, action) => ({
        ...state,
        labels: action.payload,
    }))
        .addCase(validateStockRequest, (state) => ({
        ...state,
        validationStock: {
            status: null,
        },
    }))
        .addCase(validateStockSuccess, (state, action) => ({
        ...state,
        validationStock: {
            status: action.payload.data.status,
        },
        isLoadingCart: false,
    }))
        .addCase(validateStockFailure, (state) => ({
        ...state,
        validationStock: {
            status: Status.FAILURE,
        },
        isLoadingCart: false,
    }))
        .addCase(setValidationStockStatus, (state, action) => ({
        ...state,
        validationStock: {
            status: action.payload,
        },
    }))
        .addCase(setCreatedYamahaAccount, (state, action) => ({
        ...state,
        data: state.data
            ? {
                ...state.data,
                isGuestCart: !action.payload,
            }
            : null,
    }))
        .addCase(updateDiscountCodeRequest, (state) => ({
        ...state,
        errorData: null,
        isLoadingCart: true,
    }))
        .addCase(updateDiscountCodeSuccess, (state, action) => ({
        ...state,
        data: action.payload.data,
        isLoadingCart: false,
    }))
        .addCase(updateDiscountCodeFailure, (state, action) => ({
        ...state,
        errorData: action.payload.response.data,
        isLoadingCart: false,
    }))
        .addCase(setCartErrorData, (state, action) => ({
        ...state,
        errorData: action.payload,
    }))
        .addCase(setIsLoadingCart, (state, action) => ({
        ...state,
        isLoadingCart: action.payload,
    }))
        .addCase(setInitialCartState, (state) => ({
        ...state,
        data: null,
    }))
        .addCase(setCartQrId, (state, action) => ({
        ...state,
        cartQrId: action.payload,
    }))
        .addCase(updateShippingAddress, (state) => {
        if (state.data) {
            return {
                ...state,
                data: {
                    ...state.data,
                    shippingAddress: {
                        ...state.data.shippingAddress,
                        streetName: '',
                        additionalStreetInfo: '',
                        streetNumber: '',
                        city: '',
                        state: '',
                        postalCode: '',
                    },
                },
            };
        }
        return {
            ...state,
        };
    })
        .addCase(setDeletingCartItems, (state) => {
        return !state.data
            ? state
            : {
                ...state,
                data: {
                    ...state.data,
                    entries: [],
                },
            };
    })
        .addCase(updateStockQuantityProduct, (state, action) => {
        const { sku, stock, quantity } = action.payload;
        const updatedEntries = state.data ? cloneDeep(state.data.entries) : [];
        const indexEntry = updatedEntries.findIndex((entry) => entry.product.variants[0].sku === sku);
        updatedEntries[indexEntry].quantity = quantity;
        updatedEntries[indexEntry].product.variants[0].stock = stock;
        return !state.data
            ? state
            : {
                ...state,
                data: {
                    ...state.data,
                    entries: updatedEntries,
                },
            };
    })
        .addCase(setCartState, (state, action) => ({
        ...state,
        data: state.data
            ? {
                ...state.data,
                state: action.payload,
            }
            : state.data,
    }));
});
const initialExternalCartState = {
    isOpenModal: false,
    isLoadingCart: false,
    data: null,
};
export const reducerExternalCart = createReducer(initialExternalCartState, (builder) => {
    builder
        .addCase(addProductToExternalCartRequest, (state) => ({
        ...state,
        isLoadingCart: true,
    }))
        .addCase(addProductExternalToCartSuccess, (state, action) => ({
        ...state,
        data: action.payload,
        isLoadingCart: false,
        isOpenModal: true,
    }))
        .addCase(addProductExternalToCartFailure, (state) => ({
        ...state,
        data: null,
        isLoadingCart: false,
    }))
        .addCase(closeCartModal, (state) => ({
        ...state,
        isOpenModal: false,
    }))
        .addCase(getExternalCartSuccess, (state, action) => ({
        ...state,
        data: action.payload,
        isLoadingCart: false,
    }))
        .addCase(getExternalCartFailure, (state) => ({
        ...state,
        data: null,
    }));
});
